import React, { useEffect, useState } from "react";
import { BasketDeliveryData, BasketProducts, BasketSummary } from "../../components/BasketComponents";
import { useNavigate } from "react-router-dom";
import { getBasket } from "../../configs/ordersConfig"; 
import { getProductsVariables } from "../../configs/productsConfig"; 
import toast from "react-hot-toast";


function Basket() {
    const navigate = useNavigate();
    const [productsInBasket, setProductsInBasket] = useState([]);
    const [productsVariables, setProductsVariables] = useState([]);
    const [deliveries, setDeliveries] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    
    const [selectedDelivery, setSelectedDelivery] = useState({
        deliveryId : null,
        deliveryCode : null
    });

    const [deliveryData, setDeliveryData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        postalcode: '',
        city: '',
        street: '',
        houseNumber: '',
        note: ''
    });

    const [buyWithoutRegistration, setBuyWithoutRegistration] = useState(false);

    const [billingData, setBillingData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        postalcode: '',
        city: '',
        street: '',
        houseNumber: '',
        note: ''
    });
    
    const [components, setComponents] = useState({
        productsComponent: true,
        deliveryDataComponent: false,
        summaryComponent: false
    });

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const basketData = await getBasket();
                setProductsInBasket(basketData);

                if (basketData.length > 0) {

                    const productPairs = basketData.map(item => ({
                        productId: item.productId,
                        productOptionId: item.productOptionId
                    }));
                    const variablesData = await getProductsVariables(productPairs);
                    setProductsVariables(variablesData);
                }

            } catch (error) {
                console.error(error);
            }
        };
        fetchProducts();
    }, []);
    
    const changeComponent = async (e, component, next = true) => {
        e.preventDefault();

        if (next && !buyWithoutRegistration && !isLoggedIn){
            navigate("/login");
            return;
        };

        if (!next && component == 'productsComponent') {
            setSelectedDelivery({
                deliveryId: null,
                deliveryCode: null
            });
            setBillingData({
                name: '',
                email: '',
                phoneNumber: '',
                postalcode: '',
                city: '',
                street: '',
                houseNumber: '',
                note: ''
            });
            setDeliveryData({
                name: '',
                email: '',
                phoneNumber: '',
                postalcode: '',
                city: '',
                street: '',
                houseNumber: '',
                note: ''
            });
            setBuyWithoutRegistration(false);
        };

        if (next && selectedDelivery.deliveryId === null) {
            toast.error('Válassz szállítási opciót!');
            return;
        };

        if (next && component == 'summaryComponent') {

            const requiredBillingFields = [
                billingData.name,
                billingData.phoneNumber,
                billingData.postalcode,
                billingData.city,
                billingData.street,
                billingData.houseNumber
            ];
            const requiredDeliveryFields = [
                deliveryData.name,
                deliveryData.postalcode,
                deliveryData.city,
                deliveryData.street
            ];

            const hasEmptyBillingField = requiredBillingFields.some(field => !field || field.trim() === '');
            const hasEmptyDeliveryField = requiredDeliveryFields.some(field => !field || field.trim() === '');

            if (hasEmptyBillingField) {
                toast.error('Kérlek, tölts ki minden kötelező számlázási mezőt!');
                return;
            } else if(hasEmptyDeliveryField) {
                toast.error('Kérlek, tölts ki minden kötelező szállítási mezőt!');
                return;
            };
        };


        const newState = {
            productsComponent: false,
            deliveryDataComponent: false,
            summaryComponent: false
        };
        newState[component] = true;
        setComponents(newState);
    };

    useEffect(() => {
        const refresh = sessionStorage.getItem('refreshtoken');

        if (!refresh) {
            setIsLoggedIn(false);
            return;
        }

        const token = JSON.parse(refresh);

        if (Date.now() > token) {
            sessionStorage.removeItem('refreshtoken');
            setIsLoggedIn(false);
        } else {
            setIsLoggedIn(true);
            setBuyWithoutRegistration(false);
        }
    }, [changeComponent]);

    return (
        <div className='container-lg p-0 py-3'>

            <h2 className={`mx-2`}>Kosár</h2>
            {
                productsInBasket.length > 0 ? (
                    <div className={`d-flex flex-column align-items-center ${components.productsComponent ? '' : 'd-none'}`}>

                        <BasketProducts productsInBasket={productsInBasket} productsVariables={productsVariables} setProductsInBasket={setProductsInBasket} selectedDelivery={selectedDelivery} setSelectedDelivery={setSelectedDelivery} deliveries={deliveries} setDeliveries={setDeliveries}/>

                        <div className={`my-2 ${isLoggedIn ? 'd-none' : ''}`}>
                            <input className="form-check-input" type="checkbox" checked={buyWithoutRegistration} onChange={()=>setBuyWithoutRegistration(!buyWithoutRegistration)} id="buyWithoutRegistration" />
                            <label className="form-check-label ms-2" htmlFor="buyWithoutRegistration">
                                Regisztráció nélkül vásárolok
                            </label>
                        </div>

                        <button className="btn btn-home-primary" onClick={(e) => changeComponent(e, 'deliveryDataComponent')}>Folytatás <i className="bi bi-arrow-right"></i></button>

                    </div>
                    ) : <h6 className="ms-3">Nincs termék a kosárban!</h6>
            }




            <div className={`${components.deliveryDataComponent ? '' : 'd-none'} d-flex flex-column align-items-start`}>

                <button className="btn ms-3" onClick={(e) => changeComponent(e, 'productsComponent', false)}><i className="bi bi-arrow-left"></i> Vissza</button>

                <BasketDeliveryData selectedDelivery={selectedDelivery} deliveryData={deliveryData} billingData={billingData} setBillingData={setBillingData} setDeliveryData={setDeliveryData} buyWithoutRegistration={buyWithoutRegistration}/>
                

                <button className="btn btn-home-primary mx-auto" onClick={(e) => changeComponent(e, 'summaryComponent')}>Folytatás <i className="bi bi-arrow-right"></i></button>
                
            </div>




            <div className={`${components.summaryComponent ? '' : 'd-none'} d-flex flex-column align-items-start`}>

                <button className="btn ms-3" onClick={(e) => changeComponent(e, 'deliveryDataComponent', false)}><i className="bi bi-arrow-left"></i> Vissza</button>
                <BasketSummary productsInBasket={productsInBasket} productsVariables={productsVariables} deliveryData={deliveryData} billingData={billingData} selectedDelivery={selectedDelivery} deliveries={deliveries} buyWithoutRegistration={buyWithoutRegistration}/>
                
            </div>

        </div>

    );
}

export default Basket;